// extracted by mini-css-extract-plugin
module.exports = {"ListItem":"socialLinks-module--ListItem--uTaF3"};